import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import {
  BurgerWrapper,
  ConnectWalletButton,
  LayoutWrapperForMobile,
  Logo,
  LogoWrapper,
  MenuGroupWrapper,
  MobileHeaderWrapper,
  OpenMenuUnderlay,
  OpenMenuWrapper,
  WalletIcon,
} from './styling/mobile'
import { MobilePending } from '../../buttons/wallet-button/styled'

import { Hamburger } from '../../checkbox/hamburger/index'
import Jazzicon from 'react-jazzicon/dist/Jazzicon'
import { LayoutWrapper } from '../../../styling/common'
import { MobileNavigation } from './navigation/mobile/main-menu'
import { NestedNavListProps } from './navigation/use-active-linking'
import Path from 'router'
import React from 'react'
import { getAllProducts } from '../../../indices-list'
import { jsNumberForAddress } from 'react-jazzicon'
import { useMultiTransactionState } from 'services/pending-transactions-context'
import { useNavigate } from 'react-router-dom'
import { useStore } from 'services/store'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useConnectModal } from '@rainbow-me/rainbowkit'
import { useAccount } from 'wagmi'
import { PortfolioReturns } from './navigation/storage/interface'
import { zeroAddress } from 'viem'

type Props = {
  portfolioReturns: PortfolioReturns
  clickControlReference: React.RefObject<HTMLDivElement>
}

export const MobileHeader: React.FC<Props> = ({ clickControlReference, portfolioReturns }) => {
  // state that controls the open menu
  const { isNavOpen, setNavOpen, connectionModal, setConnectionModal } = useStore()
  const { pending } = useMultiTransactionState()
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.NavigationBar)
  const navigate = useNavigate()
  const { isConnected, isConnecting, address } = useAccount()
  const { openConnectModal } = useConnectModal()
  const [walletConnected, setWalletConnected] = React.useState<boolean>(false)
  const [selectedItem, setSelectedItem] = React.useState<NestedNavListProps>()
  const { run, currentStep, menuOpen } = useTourGuide()

  // method that controls the open menu
  const toggleOpenMenu = () => {
    setNavOpen(!isNavOpen)
    if (isNavOpen) {
      setSelectedItem(undefined)
    }
    // if the connection modal is open, close it
    if (connectionModal) setConnectionModal(false)
  }

  const handleNavigate = () => {
    setNavOpen(false)
    setSelectedItem(undefined)
    navigationEvent(`${Path.MAIN}`)
    navigate(`${Path.MAIN}`)
  }

  const buttonHandler = () => {
    if (!isConnected && !isConnecting && openConnectModal) {
      openConnectModal()
    } else if (!connectionModal) {
      setConnectionModal(true)
    }
  }

  const showDot = () => {
    if (!isNavOpen) {
      if (pending) return <MobilePending />
      return null
    }
    return null
  }

  React.useEffect(() => {
    setWalletConnected(isConnected)
  }, [isConnected])

  React.useEffect(() => {
    let timer: NodeJS.Timeout
    const runningOrPaused = run || currentStep > 0
    if (runningOrPaused && menuOpen === 'OPEN') {
      setNavOpen(true)
    } else {
      setNavOpen(false)
    }
    return () => clearTimeout(timer)
  }, [menuOpen, currentStep])

  const showConnectOrJazz = () => {
    const runningOrPaused = run || currentStep > 0
    //if we are connected, show jazzicon
    if (runningOrPaused || walletConnected) {
      const getSeed = () =>
        jsNumberForAddress(runningOrPaused ? getAllProducts()[0].address : address ?? zeroAddress)
      return (
        <WalletIcon onClick={buttonHandler}>
          <Jazzicon diameter={24} seed={getSeed()} />
        </WalletIcon>
      )
    } else {
      //if we are not connected, show connect button
      return (
        <ConnectWalletButton onClick={buttonHandler} buttonType="wallet">
          Connect
        </ConnectWalletButton>
      )
    }
  }

  return (
    <>
      <LayoutWrapperForMobile>
        <LayoutWrapper>
          <MobileHeaderWrapper tabIndex={0} ref={clickControlReference}>
            <LogoWrapper onClick={handleNavigate}>
              <Logo fileName={'whale'} additionalState={'header'} alt={'Phuture Logo'} />
            </LogoWrapper>
            <MenuGroupWrapper>
              {showConnectOrJazz()}
              <BurgerWrapper onClick={toggleOpenMenu}>
                {showDot()}
                <Hamburger isOpen={isNavOpen} />
              </BurgerWrapper>
            </MenuGroupWrapper>
            <OpenMenuWrapper isOpen={isNavOpen}>
              <MobileNavigation
                portfolioReturns={portfolioReturns}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                closeMenu={() => setNavOpen(false)}
              />
            </OpenMenuWrapper>
          </MobileHeaderWrapper>
        </LayoutWrapper>
      </LayoutWrapperForMobile>
      <OpenMenuUnderlay isOpen={isNavOpen} />
    </>
  )
}
